// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-tsx": function componentSrcPages404Tsx() {
    return import("./../../src/pages/404.tsx"
    /* webpackChunkName: "component---src-pages-404-tsx" */
    );
  },
  "component---src-pages-copyright-tsx": function componentSrcPagesCopyrightTsx() {
    return import("./../../src/pages/copyright.tsx"
    /* webpackChunkName: "component---src-pages-copyright-tsx" */
    );
  },
  "component---src-pages-index-tsx": function componentSrcPagesIndexTsx() {
    return import("./../../src/pages/index.tsx"
    /* webpackChunkName: "component---src-pages-index-tsx" */
    );
  },
  "component---src-pages-login-tsx": function componentSrcPagesLoginTsx() {
    return import("./../../src/pages/login.tsx"
    /* webpackChunkName: "component---src-pages-login-tsx" */
    );
  },
  "component---src-pages-logout-tsx": function componentSrcPagesLogoutTsx() {
    return import("./../../src/pages/logout.tsx"
    /* webpackChunkName: "component---src-pages-logout-tsx" */
    );
  },
  "component---src-pages-privacy-tsx": function componentSrcPagesPrivacyTsx() {
    return import("./../../src/pages/privacy.tsx"
    /* webpackChunkName: "component---src-pages-privacy-tsx" */
    );
  },
  "component---src-pages-terms-tsx": function componentSrcPagesTermsTsx() {
    return import("./../../src/pages/terms.tsx"
    /* webpackChunkName: "component---src-pages-terms-tsx" */
    );
  },
  "component---src-templates-menu-tsx": function componentSrcTemplatesMenuTsx() {
    return import("./../../src/templates/menu.tsx"
    /* webpackChunkName: "component---src-templates-menu-tsx" */
    );
  },
  "component---src-templates-people-tsx": function componentSrcTemplatesPeopleTsx() {
    return import("./../../src/templates/people.tsx"
    /* webpackChunkName: "component---src-templates-people-tsx" */
    );
  },
  "component---src-templates-place-tsx": function componentSrcTemplatesPlaceTsx() {
    return import("./../../src/templates/place.tsx"
    /* webpackChunkName: "component---src-templates-place-tsx" */
    );
  },
  "component---src-templates-places-tsx": function componentSrcTemplatesPlacesTsx() {
    return import("./../../src/templates/places.tsx"
    /* webpackChunkName: "component---src-templates-places-tsx" */
    );
  }
};